/**
 * To be used by humanizeDuration (default export) of `humaniize-duration` package.
 */
export const humanizeDurationUnitMeasures = {
  y: 31557600000,
  // default was 2629800000 = 30,4375 days -> leads to quirky results when showing long periods in whole days.
  mo: 30 * 86400000,
  w: 604800000,
  d: 86400000,
  h: 3600000,
  m: 60000,
  s: 1000,
  ms: 1,
};
